import React from 'react';
import PropTypes from 'prop-types';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
} from '@tcp/core/src/utils/labels/globalActions.labels';
import { SECTION_MODE } from '../../container/SinglePageCheckout.constants';
import { isAddressSaved } from '../../container/Shipping/Shipping.utils';
import SectionHeader from '../common/SectionHeader';
import { REG_FORM_MODE } from '../../container/Shipping/Shipping.constants';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblShipping,
} from '../../../../../../utils/labels/globalGeneric.labels';

const ShippingHeader = (props) => {
  const {
    savedAddress,
    section,
    handleEdit,
    handleCancel,
    updateSectionState,
    isGuestUser,
    bossSwitchEnabled,
  } = props;
  const globalActionsLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ACTIONS_LABELS,
    GlobalActionsLabels
  );
  const { disabled, isExpanded, registeredUserFormMode } = section;
  const isAddrSaved = isAddressSaved(savedAddress);
  const isHideAction =
    registeredUserFormMode === REG_FORM_MODE.EDIT_ADDRESS ||
    registeredUserFormMode === REG_FORM_MODE.ADD_NEW_ADDRESS;
  const showEditCTA = isAddrSaved && section.mode === SECTION_MODE.SECTION_VIEW_MODE && !isExpanded;
  const actionLabel = showEditCTA
    ? renderLabel(globalActionsLabels.lbl_edit, 'lbl_edit')
    : renderLabel(globalActionsLabels.lbl_cancel, 'lbl_cancel');

  return (
    <SectionHeader
      disabled={disabled}
      handleOnClick={() => {
        if (!isAddrSaved) {
          updateSectionState({ isExpanded: !isExpanded });
        }
      }}
      headerIcon="shipping-section"
      headerAltLabel={renderLabel(
        getLabelFromCopyOrFromTranslation(
          `${GLOBAL_GENERIC_LABELS}.${lblShipping}`,
          GlobalGenericLabels
        ),
        'lbl_shipping'
      )}
      headerDataLocator="shippingIcon"
      heading={renderLabel(
        getLabelFromCopyOrFromTranslation(
          `${GLOBAL_GENERIC_LABELS}.${lblShipping}`,
          GlobalGenericLabels
        ),
        'lbl_shipping'
      )}
      headingDataLocator="shippingHdr"
      showAction={isAddrSaved && (!isHideAction || !isExpanded || isGuestUser)}
      actionClassName="underline"
      actionLabel={actionLabel}
      actionAriaLabel={actionLabel}
      actionDataLocator={showEditCTA ? 'editShipping' : 'cancelEditShipping'}
      handleOnActionClick={showEditCTA ? handleEdit : handleCancel}
      isExpanded={isExpanded}
      bossSwitchEnabled={bossSwitchEnabled}
    />
  );
};

ShippingHeader.propTypes = {
  section: PropTypes.shape({}).isRequired,
  savedAddress: PropTypes.shape({}),
  handleEdit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  updateSectionState: PropTypes.func.isRequired,
  isGuestUser: PropTypes.bool,
};

ShippingHeader.defaultProps = {
  savedAddress: {},
  isGuestUser: false,
};

export default ShippingHeader;
